import { get } from '@styled-system/core';

export const withComponentTheme = <T extends { theme?: unknown }>(
  props: T
) => ({
  ...props,
  theme: get(props.theme, 'components', {}),
});
